import { doc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import { firestore } from "@/firebase";
import { Maintenance } from "@t3/shared";
import { useEffect, useState } from "react";

export const useMaintenanceMode = () => {
  const [lastSeenVersion, setLastSeenVersion] = useState<string | null>(null);
  const [value, loading, error] = useDocument(
    doc(firestore, "global-configs", "maintenance"),
  );

  const result = value?.data() as Maintenance | undefined;

  useEffect(() => {
    if (result?.version) {
      if (lastSeenVersion && lastSeenVersion !== result?.version) {
        console.error("Version mismatch, reloading");
        window.location.reload();
      }
      setLastSeenVersion(result?.version);
    }
  }, [result?.version]);

  return [result, loading, error] as const;
};
